import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as appHelper from '../../helpers/appHelper';
import * as animationHelper from "../../helpers/animationHelper";
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as objectConstants from "../../constants/objectConstants";

class Button extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.show = this.show.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onKeyboardClick = this.onKeyboardClick.bind(this);

        this.button = React.createRef();
    }

    componentDidMount() {
        this.show();
    }

    componentWillReceiveProps(nextProps) {

    }

    show(){
        let button = this.button.current;
        if(appHelper.isObjectEleDefined(button)) {
            let params = {
                ele: button,
                duration: objectConstants.BUTTON_DURATION,
                delay: 0,
                callback: this.onComplete
            };
            animationHelper.showHeight(params);
        }
    }

    onComplete(){
        if(appHelper.isDefined(this.props.onRevealed)){
            this.props.onRevealed();
        }
    }

	onKeyboardClick(event) {
		if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
			event.preventDefault();
			this.props.onClick();
		}
	}

    render() {

        return (
            <div className="a-c" ref={this.button}>
            <div className=" text-center" >
                <input
                    type="submit"
                    disabled={this.props.isDisabled}
                    tabIndex={"0"}
                    ref={this.props.id}
					id={this.props.id}
                    value={this.props.label}
                    className="btn btn-lg action-btn guroo-btn"
                    onClick={this.props.onClick}
					onKeyDown={this.onKeyboardClick}
                />
            </div>
            </div>
        );
    }
}

Button.propTypes = {
    label: PropTypes.string.isRequired,
    id:PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    onRevealed: PropTypes.func
};

Button.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Button);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/Button.js
 **/